export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/crack.2587bfdd.svg","height":165,"width":165,"blurWidth":0,"blurHeight":0};